/**
 * Mappe la valeur d'enum DB de disponibilité ("DISPONIBLE"/"LOUÉ"/"VENDU"/
 * "EN PRÉPARATION") vers son libellé i18n. Le badge applique `uppercase` en CSS.
 * Fallback : la valeur brute si inconnue.
 */
export function disponibiliteLabel(
  raw: string | null | undefined,
  t: (k: string) => string,
): string {
  const upper = (raw || "").toUpperCase();
  switch (upper) {
    case "DISPONIBLE":
    case "EN PRÉPARATION": // legacy, traité comme disponible
      return t("options.disponibilite.disponible");
    case "LOUÉ":
      return t("options.disponibilite.loue");
    case "VENDU":
      return t("options.disponibilite.vendu");
    default:
      return raw || "";
  }
}
